'use client';

import React, { useState } from 'react';

import { Heading } from '../Heading/Heading';
import { Text } from '../Text/Text';
import { GetSpeciesTopBaits_topProductUnits_edges_node } from '../../interfaces/graphql';
import { twMerge } from 'tailwind-merge';
import { Button } from '../Clickables/Buttons/Button';
import { useAnalytics } from '../../contexts/AnalyticsContext/AnalyticsContext';
import { trackEvent } from '../../helpers/analytics/trackEvent';
import { TopBaitsEntry } from './components/TopBaitsEntry';
import { TopBaitsSectionCTA } from './components/TopBaitsSectionCTA';
import { AppDownloadModal } from '../AppDownloadModal/AppDownloadModal';

interface IProps {
  className?: string;
  topBaits?: GetSpeciesTopBaits_topProductUnits_edges_node[];
  sourceId?: string;
  id?: string;
  headingText?: string;
  descriptionText?: string;
  appDownloadModalText?: string;
}

export const TopBaitsSection = ({
  className,
  topBaits,
  sourceId,
  id = 'top-baits-section',
  headingText = 'Best baits',
  descriptionText,
  appDownloadModalText,
}: IProps) => {
  const { currentPage } = useAnalytics();
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);
  const hasTopBaits = topBaits && topBaits.length > 0;

  const handleCTAClick = () => {
    void trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        source: 'TopBaitsSection',
        source_id: sourceId,
        type: 'downloadModal',
        page: currentPage,
      },
    });
    setIsAppDownloadModalOpen(true);
  };

  return (
    <div
      id={id}
      className={twMerge(
        'sm:bg-lake-fog scroll-mt-(--navigation-scrolltop-offset-mobile) sm:scroll-mt-(--navigation-scrolltop-offset) sm:rounded-2xl',
        className,
      )}
    >
      <Heading className="mx-auto text-left" variant="sm">
        {headingText}
      </Heading>
      {descriptionText && <Text className="my-5">{descriptionText}</Text>}

      <div className="flex flex-col">
        <TopBaitsSectionCTA sourceId={sourceId} hasTopBaits={hasTopBaits} />
        {topBaits?.map(({ productUnit, numberOfCatches, position }) => {
          return (
            <TopBaitsEntry
              key={`species-${productUnit.id}`}
              productUnit={productUnit}
              numberOfCatches={numberOfCatches}
              position={position}
              onClick={handleCTAClick}
            />
          );
        })}
        {hasTopBaits && (
          <Button size="sm" className="mt-2 p-2" variant="textPrimary" onClick={handleCTAClick}>
            Show more baits
          </Button>
        )}
      </div>
      <AppDownloadModal
        appDownloadSource="TopBaitsSection"
        appDownloadSourceId={sourceId}
        modalHeader={appDownloadModalText}
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </div>
  );
};
